import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import Comment from "../jira_priority/Comment";

const ShowMoreDrop = ({ addNotesHandler, data }) => {
  const params = useParams();

  const [show, setShow] = useState(false);
  const [copied, setIsCopied] = useState(false);
  const moredropref = useRef(null);
  const location = useLocation();

  const coptTodoLinkHandler = async (e, uuid) => {
    e.stopPropagation();
    let url = `${window.location.origin}/tattle/${params.attribute_set_key}/${uuid}`;
    await navigator.clipboard?.writeText(url);
    setIsCopied(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", mouseMoveHandler);

    return () => {
      document.removeEventListener("mousedown", mouseMoveHandler);
    };
  }, []);

  const mouseMoveHandler = (e) => {
    if (moredropref.current && !moredropref.current.contains(e.target)) {
      setShow(false);
    }
  };
  const showMoreDropDownhandler = (e) => {
    e.stopPropagation();
    setShow(true);
  };
  useEffect(() => {
    setTimeout(() => {
      setIsCopied(false);
    }, 700);
  }, [copied]);
  return (
    <div
      className="notesbtn"
      onClick={(e) => coptTodoLinkHandler(e, data.customer_tattle_uuid)}
    >
      <OverlayTrigger
        key={"medium"}
        placement={"top"}
        overlay={
          <Tooltip id={`medium`}>
            <strong>Copy Link</strong>
          </Tooltip>
        }
      >
        <ul>
          <li style={{ position: "relative", display: "flex" }}>
            <i
              className="fa fa-link"
              style={{
                fontWeight: "normal",
                fontSize: "11px",
                color: "#475569",
              }}
            ></i>{" "}
            {copied && (
              <span
                className={`copy_link kanbancopylink`}
                style={{
                  position: "absolute",
                  bottom: -10,
                  left: -20,
                  fontSize: "12px",
                  width: "52px",
                }}
              >
                Copied
              </span>
            )}
          </li>
        </ul>
      </OverlayTrigger>
    </div>
  );
  // return (
  //   <div className="notesbtn" onClick={showMoreDropDownhandler}>
  //     <i
  //       class="fa fa-ellipsis-v"
  //       aria-hidden="true"
  //       style={{ fontSize: "15px", fontWeight: "normal" }}
  //     ></i>
  //     {show && (
  //       <div className="moredropdown" ref={moredropref}>
  //         <ul>
  //           <li onClick={addNotesHandler.bind(this, data)}>
  //             <Comment /> &nbsp;Notes
  //           </li>
  //           <li
  //             onClick={() => coptTodoLinkHandler(data.customer_tattle_uuid)}
  //             style={{ position: "relative" }}
  //           >
  //             <i
  //               className="fa fa-link"
  //               style={{
  //                 fontWeight: "normal",
  //                 fontSize: "11px",
  //                 color: "#475569",
  //               }}
  //             ></i>{" "}
  //             &nbsp; Copy Link
  //             {copied && (
  //               <span
  //                 className={`copy_link kanbancopylink`}
  //                 style={{ position: "absolute", bottom: -10, left: 0 }}
  //               >
  //                 Copied
  //               </span>
  //             )}
  //           </li>
  //         </ul>
  //       </div>
  //     )}
  //   </div>
  // );
};

export default React.memo(ShowMoreDrop);
